<div class="port-stub">
  <div class="port-stub-rows">
    <div class="port-stub-row">
      <span class="port-stub-label">Название</span>
      <span class="port-stub-value">{{ port.name }}</span>
    </div>

    <div class="port-stub-row">
      <span class="port-stub-label">Тип</span>
      <span class="port-stub-value">
        {{ port.type === 'RELAY' ? 'Реле' : 'Датчик' }}
      </span>
    </div>

    <div class="port-stub-row">
      <span class="port-stub-label">Номер порта</span>
      <span class="port-stub-value">{{ port.portNumber }}</span>
    </div>

    <div class="port-stub-row">
      <span class="port-stub-label">Активен</span>
      <span class="port-stub-value">{{ port.active ? 'Да' : 'Нет' }}</span>
    </div>
  </div>

  @if (hasActiveSession) {
    <div
      class="session-box"
      [ngClass]="
        port.activeSession?.type === 'WORKING' ? 'is-working' : 'is-technical'
      "
    >
      <div class="session-header">
        <div class="session-title">Активная сессия</div>
        <div
          class="session-badge"
          [ngClass]="
            port.activeSession?.type === 'WORKING'
              ? 'is-working'
              : 'is-technical'
          "
        >
          {{ sessionTypeLabel }}
        </div>
      </div>

      <div class="session-time">
        Начата:
        {{ port.activeSession?.startedAt | date: 'dd.MM.yyyy, HH:mm' }}
      </div>

      <button
        type="button"
        class="btn btn-danger session-action-btn"
        [disabled]="isLoading"
        (click)="endSession()"
      >
        @if (isLoading) {
          <div class="spinner-small"></div>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          </svg>
        }
        Завершить сессию
      </button>
    </div>
  } @else {
    <div class="session-box no-session">
      <div class="session-title">Нет активной сессии</div>
      <p class="session-hint">
        Запустите сессию, чтобы начать работу с этим портом.
      </p>

      <div class="session-start-options">
        <button
          type="button"
          class="btn btn-success"
          [disabled]="isLoading"
          (click)="startSession('WORKING')"
        >
          @if (isLoading) {
            <div class="spinner-small"></div>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          }
          Запустить рабочую
        </button>

        <button
          type="button"
          class="btn btn-outline"
          [disabled]="isLoading"
          (click)="startSession('TECHNICAL')"
        >
          @if (isLoading) {
            <div class="spinner-small"></div>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
              />
            </svg>
          }
          Запустить техническую
        </button>
      </div>
    </div>
  }
</div>
